import {note} from 'shared/icons/index';

export default {
  type: 'editor.elements.PageElement',
  name: 'Page Design',
  id: 'page',
  icon: note,
  staticElement: true,
  order: 20,
  tooltip: 'Design the general look of you listing. Choose color, texture, border etc.',
};
